// extracted by mini-css-extract-plugin
export default {"container":"OrganisationGrid-module--container--a4fcc","logo":"OrganisationGrid-module--logo--02718","text":"OrganisationGrid-module--text--7d9e3"};